console.log('customjs loaded')

function checkForRechargeNotFoundPage() {
  const rechargeHeader = $(".rc_header-settings__description")

  if (rechargeHeader.length > 0) {
    $(".rc_layout__full").find("a").hide()
    $(".rc_layout__full").find(".col-md-6").removeClass('col-md-6').addClass('col-md-12')
    $(".rc_header-settings").addClass("rc_merlo_container")
    $(".rc_header-settings").append("<p style='margin-top:50px'><a href='/pages/coffee-subscriptions' style='color:#0077C8; border-bottom: 1px solid #0077C8;'>Click here</a> to find out more about setting up a recurring subscription.</p>")
    $(".rc_header-settings").append("<p style='margin-top:30px'>Need help accessing your subscription? <a href='/pages/contact-us' style='color:#0077C8; border-bottom: 1px solid #0077C8;'>Click here</a> to contact the team.</p>")
  }
}

function isIOSMobileOrTablet() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && (window.innerWidth <= 1024);
}

checkForRechargeNotFoundPage()
$(document).ready(function () {
  addClassToRechargeSelect()
  if (!isIOSMobileOrTablet()) {
    $(".search_details").on('click', function (e) {
      setTimeout(() => {
        $('#Search-In-Modal-Menu-Utility').focus()
      }, 500)
    })
    $(".header__icon--search").on('click', function (e) {
      setTimeout(() => {
        $('#Search-In-Modal-Sidebar').focus()
      }, 500)
    })
  }
  // this is doubled up on purpose further down
  updateProductTitleHeights();
})

function addClassToRechargeSelect() {
  const observer = new MutationObserver(function (mutations) {
    if ($(".rc-selling-plans-dropdown__select").length) {
      $(".rc-selling-plans-dropdown__select").addClass('select__select')
      $(".rc-selling-plans-dropdown__select").css('margin-top', "12px")
      observer.disconnect(); // Stop observing once the element is found
    }
  });
  // Start observing changes in the document's body
  observer.observe(document.body, { childList: true, subtree: true });
}

var getFormValues = function getFormValues(formTarget) {
  const formData = new FormData(formTarget);

  // Find all checkboxes in the form and update their values in formData
  formTarget.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
    // If the checkbox is unchecked, set its value to 'false'
    // If checked, set its value to 'true' (or use the checkbox's value attribute if needed)
    formData.set(checkbox.name, checkbox.checked ? checkbox.value || 'true' : 'false');
  });

  // Convert FormData to an object
  return Object.fromEntries(formData.entries());
}

var toggleButtonSpinner = function toggleButtonSpinner(target, showSpinner) {
  const button = $(target).find('button[type="submit"]');
  const spinner = $(target).find(`.spinner-border`);

  if (showSpinner) {
    button.prop('disabled', true);      // Disable the button
    spinner.removeClass('d-none');      // Show the spinner
  } else {
    button.prop('disabled', false);     // Enable the button
    spinner.addClass('d-none');         // Hide the spinner
  }
}

var phoneNumberValidationRules = function (elementId, getCountryCode, errorMessageCallback = null) {
  return [
    {
      rule: 'required',
      errorMessage: (value, context) => {
        return "You must enter your mobile number."
      }
    },
    {
      validator: (value, context) => {
        if (!value) {
          return false
        }
        const countryCode = getCountryCode(value, context)
        const parsedNumber = parsePhoneNumber(value, {
          regionCode: countryCode
        });
        if (!parsedNumber.valid) {
          return false;
        }
        if (!parsedNumber.number.international // will return the full number, with spaces
          .replace(/[^\d+]+/g, '').match(/^\+(642|614)/)) {
          return false;
        }
        $(context[elementId].elem).val(parsedNumber.number.international.replace(/[^\d+]+/g, ''));
        return true
      },
      errorMessage: (value, context) => {
        const countryCode = getCountryCode(value, context)
        if (errorMessageCallback) {
          return errorMessageCallback(countryCode, value, context)
        }
        return "You must enter a valid mobile number for the selected country"
      }
    },
  ]
}

var getCountryCodeFromJustValidate = function (value, context) {
  const foundElem = Object.keys(context).find(key => {
    const element = context[key].elem;

    // Check if the element is the phone input
    if (element && element.id === "country") {
      return true;
    }
    return false
  })

  let countryCode = 'AU'
  if ($(context[foundElem].elem).val()?.toLowerCase() === 'new zealand') {
    countryCode = 'NZ';
  }

  return countryCode
}

function updateDynamicHeights() {
  const headerHeight = $('.header-navigation-wrapper').outerHeight() || 0; // Get the header height
  const announcementBarHeight = $('.announcement-bar').outerHeight() || 0; // Get the announcement bar height

  // Set CSS variables for dynamic heights
  if (headerHeight > 0) {
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  }
  if (announcementBarHeight > 0) {
    document.documentElement.style.setProperty('--announcement-bar-height', `${announcementBarHeight}px`);
  }
}

function updateProductTitleHeights() {
  $(".card-title").removeAttr("style").css('-webkit-line-clamp', "2")
}

function equalizeHeights() {
  const elements = document.querySelectorAll('.card-information');
  let maxHeight = 0;

  // Find the maximum height
  elements.forEach((el) => {
    el.style.height = ''; // Reset height to calculate natural height
    const elementHeight = el.offsetHeight;
    if (elementHeight > maxHeight) {
      maxHeight = elementHeight;
    }
  });

  // Apply the maximum height to all elements
  elements.forEach((el) => {
    el.style.minHeight = `${maxHeight}px`;
  });
}

// Call the function to set heights on page load
updateDynamicHeights();
updateProductTitleHeights();
equalizeHeights();

// Optional: Update heights on window resize
$(window).on('resize', function () {
  updateDynamicHeights();
  equalizeHeights();
});